var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-4 relative"},[_c('popper',{attrs:{"trigger":"click","options":{
      placement: _vm.placement,
      modifiers: {
        offset: {
          offset: '0,8px'
        }
      }
    }},on:{"show":function($event){return _vm.$emit('show')}}},[_c('div',{staticClass:"bg-white shadow-md min-w-32 z-30"},[_vm._t("default")],2),_vm._v(" "),_c('button',{staticClass:"transition-all trainsition-normal focus:outline-none",class:_vm.buttonClass ? _vm.buttonClass : 'w-4 hover:opacity-50',attrs:{"slot":"reference","type":"button"},slot:"reference"},[_vm._t("icon",[_c('icon',{staticClass:"w-6 h-6 icons-black",attrs:{"icon":"dots-vertical"}})])],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }